import MasterTab from 'src/components/Layouts/MasterTab.vue';
import ExternalQuality from "src/views/Pages/Dashboard/Grow/Reports/ExternalQuality/ExternalQuality.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const ExternalQualityRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'externalqualityreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.externalquality',
          component: ExternalQuality,
          meta: {
            prefix_permission: 'grow_externalquality',
          },
        },
      ],
    },
  ],
};

export default ExternalQualityRoutes;
